import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { SmsRecordControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseData,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  patientUuid?: string;
  xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useCommunicationMessages = ({
  pagination,
  gridSorting,
  patientUuid,
  xTENANTID,
}: Props): useBaseData<any> => {
  const sortDirect = gridSorting?.[0]?.sort ?? undefined;

  return useQuery({
    queryKey: [
      "communication-messages",
      pagination,
      gridSorting,
      patientUuid,
      xTENANTID,
    ],
    // refetchOnWindowFocus: false,
    staleTime: 0,
    enabled: !!patientUuid,
    queryFn: async () =>
      new SmsRecordControllerApi(getConfigObject())
        .getAllSmsRecord(
          pagination.page,
          pagination.pageSize, //size
          undefined, //sort by
          sortDirect,
          patientUuid,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
